<template>
  <v-layout row wrap>
    <v-flex xs12>
      <v-data-table
        :headers="headers"
        :loading="isLoading"
        :items="orderHead"
        :must-sort="false"
        class="elevation-0"
        hide-actions
      >
        <template v-slot:items="{ item: head }">
          <tr>
            <td>{{ head.orderNo }}</td>
            <td><date-output :dateString="head.orderDate"></date-output></td>
            <td>{{ head.customersOrderNo }}</td>
            <td>{{ head.orderTypeText || head.orderType }}</td>
            <td>{{ head.completeDelivery ? "Yes" : "No" }}</td>
            <td>
              <order-status-indicator
                :delivery-status="head.deliveryStatus"
                :rejection-status="head.rejectionStatus"
              ></order-status-indicator>
            </td>
          </tr>
        </template>
        <template v-slot:no-data>
          <div v-if="isLoading" style="text-align: center;">Please wait</div>
        </template>
      </v-data-table>
    </v-flex>
  </v-layout>
</template>

<script>
import { mapGetters } from "vuex";
import DateOutput from "@/components/DateOutput.vue";
import OrderStatusIndicator from "@/components/OrderStatusIndicator.vue";

export default {
  name: "OrderStatusDetailHeader",
  components: {
    DateOutput,
    OrderStatusIndicator
  },
  data() {
    return {
      search: "",
      headers: [
        {
          text: "Order No.",
          sortable: false
        },
        {
          text: "Order Date",
          sortable: false
        },
        {
          text: "Your Order No.",
          sortable: false
        },
        {
          text: "Order Type",
          sortable: false
        },
        {
          text: "Compl. Del.",
          sortable: false
        },
        {
          text: "Delivery Status",
          sortable: false
        }
      ]
    };
  },
  computed: {
    ...mapGetters(["getOrderHead"]),
    ...mapGetters("customer", {
      customerId: "getCustomerId"
    }),
    isLoading() {
      return this.$store.state.order_status.isLoadingHead;
    },
    orderHead() {
      return this.getOrderHead ? [this.getOrderHead] : [];
    }
  },
  watch: {
    customerId: function() {
      this.$store.dispatch("fetchOrderHead", {
        orderNo: this.$route.params.orderNo
      });
    }
  },
  created() {
    if (this.customerId) {
      this.$store.dispatch("fetchOrderHead", {
        orderNo: this.$route.params.orderNo
      });
    }
  }
};
</script>
